import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="footer-cta">
          <Link to="/contact" className="cta-button">Arrange Viewing</Link>
        </div>
      </div>
    </footer>
  );
};
